<template>
  <div
    class="gps-ranking-player-parts"
    :class="{ 'gps-ranking-player-parts--current': selectedPlayerID === player.id }"
  >
    <div class="gps-ranking-player-parts__card">
      <figure class="gps-ranking-player-parts__img">
        <img :src="imgPath" alt="" />
      </figure>
      <div class="gps-ranking-player-parts__lap">Lap{{ player.lap }}・{{ player.sector }}</div>
      <div class="gps-ranking-player-parts__position">
        <span class="gps-ranking-player-parts__position-label">Pos.</span>
        <span
          class="gps-ranking-player-parts__position-num"
          :class="{ 'is-small': rankingFontSizeSmall }"
          >{{ ranking || 0 }}</span
        >
      </div>
      <div class="gps-ranking-player-parts__name">
        <span class="name">
          {{ player.number ? `#${player.number}` : '' }}
          {{ player.name[$i18n.locale] }}
        </span>
        <span class="abbreviation">
          {{ player.number ? `#${player.number}` : '' }}
          {{ player.abbreviation }}
        </span>
      </div>
    </div>
    <div class="gps-ranking-player-parts__diff">
      Diff
      {{ player.valid && player.diffTime ? player.diffTime : '--' }}
    </div>

    <svg
      class="gps-ranking-player-parts__car-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1615_20993)">
        <path
          d="M0.000583219 12.1767C0.000583214 10.4375 0.000850004 8.6983 1.79808e-07 6.9591C-5.83279e-05 6.83962 0.0146244 6.72627 0.0856026 6.62579C0.185143 6.48486 0.325426 6.4208 0.493087 6.42025C1.12168 6.41818 1.75028 6.41868 2.37888 6.41968C2.69906 6.42019 2.87926 6.67682 2.8774 6.93346C2.87003 7.95403 2.87435 8.97469 2.87441 9.99531C2.87442 10.1095 2.87497 10.1111 2.98795 10.0887C3.5401 9.97939 4.09531 9.88773 4.65627 9.8414C5.04185 9.80955 5.42905 9.78926 5.81586 9.78214C6.35169 9.77227 6.88785 9.77874 7.42386 9.78067C7.49401 9.78092 7.54816 9.75801 7.60396 9.7172C7.83388 9.54905 8.06707 9.3854 8.29908 9.22011C8.79678 8.86552 9.29462 8.51114 9.79214 8.1563C10.1013 7.93578 10.4102 7.71472 10.719 7.4936C10.8272 7.41613 10.9444 7.3786 11.0804 7.37895C12.1694 7.38175 13.2585 7.38161 14.3476 7.37953C14.5482 7.37914 14.702 7.45523 14.8056 7.62626C14.9821 7.91785 15.1563 8.21085 15.3312 8.50338C15.5749 8.9108 15.8191 9.3179 16.0609 9.7264C16.0901 9.77581 16.1299 9.77992 16.1779 9.77986C16.5824 9.77935 16.9868 9.77961 17.3913 9.77961C18.2732 9.77962 19.1552 9.77965 20.0372 9.77958C20.1195 9.77957 20.1606 9.7377 20.1607 9.65398C20.1608 9.40552 20.1589 9.15704 20.1619 8.90862C20.1627 8.8407 20.1436 8.81423 20.0715 8.8147C19.65 8.81742 19.2285 8.8171 18.807 8.81496C18.741 8.81463 18.7155 8.83565 18.718 8.90299C18.722 9.01001 18.7171 9.11734 18.7195 9.22446C18.7207 9.27971 18.7014 9.30352 18.6439 9.30319C18.3734 9.3016 18.103 9.30167 17.8326 9.30321C17.7753 9.30354 17.755 9.28032 17.7563 9.22451C17.7587 9.11496 17.7544 9.00523 17.7576 8.89572C17.7593 8.83526 17.7361 8.81487 17.6766 8.81526C17.3891 8.81716 17.1016 8.81618 16.8141 8.81589C16.2751 8.81536 15.8486 8.41306 15.8425 7.87414C15.8332 7.06312 15.8332 6.25182 15.8428 5.4408C15.849 4.90783 16.2785 4.50229 16.8202 4.50128C18.0871 4.49892 19.3541 4.50046 20.621 4.50092C20.6647 4.50094 20.7087 4.50429 20.7522 4.50935C21.2181 4.56356 21.5845 4.95778 21.5965 5.42749C21.6039 5.71717 21.5986 6.00718 21.5991 6.29704C21.5992 6.37805 21.6389 6.41864 21.7182 6.41882C22.3005 6.41895 22.8828 6.41902 23.4651 6.4189C23.5844 6.41888 23.6993 6.43688 23.7974 6.51016C23.9309 6.6099 23.9991 6.74376 23.9989 6.91182C23.9985 7.30887 23.999 7.70591 23.999 8.10296C23.999 11.2062 23.9986 14.3095 24 17.4128C24.0001 17.5901 23.9487 17.7375 23.8048 17.847C23.7153 17.9152 23.6132 17.9373 23.5029 17.9371C22.9084 17.9363 22.3139 17.9367 21.7194 17.9368C21.6393 17.9369 21.5992 17.9769 21.5991 18.0571C21.5984 18.3518 21.6031 18.6467 21.5956 18.9412C21.5834 19.4202 21.1786 19.8303 20.7 19.8573C20.666 19.8592 20.6318 19.8598 20.5977 19.8598C19.3478 19.8599 18.0979 19.8587 16.8481 19.8606C16.5044 19.8612 16.2284 19.7298 16.0227 19.4562C15.9038 19.298 15.8416 19.1158 15.8411 18.9182C15.8388 18.107 15.8334 17.2958 15.8425 16.4848C15.8485 15.9504 16.2782 15.5422 16.8146 15.5386C17.0972 15.5367 17.3799 15.5362 17.6625 15.5394C17.7366 15.5403 17.7615 15.5148 17.758 15.442C17.7531 15.3399 17.7583 15.2374 17.7566 15.1351C17.7557 15.0833 17.7747 15.0601 17.8289 15.0604C18.1018 15.0617 18.3747 15.0617 18.6475 15.0605C18.702 15.0603 18.72 15.0849 18.7192 15.1362C18.7176 15.2432 18.7211 15.3503 18.7184 15.4572C18.7169 15.517 18.74 15.539 18.7998 15.5388C19.2261 15.5373 19.6525 15.537 20.0789 15.539C20.1448 15.5393 20.162 15.5119 20.1615 15.4513C20.1595 15.1907 20.1586 14.93 20.162 14.6694C20.163 14.5969 20.1353 14.5793 20.0677 14.5796C19.5512 14.5817 19.0346 14.5807 18.5181 14.5807C17.7433 14.5807 16.9685 14.5815 16.1937 14.5794C16.1224 14.5792 16.0809 14.5991 16.0428 14.6634C15.645 15.3361 15.2404 16.0049 14.8441 16.6784C14.7205 16.8884 14.5542 16.9853 14.3072 16.9838C13.2742 16.9775 12.2411 16.9763 11.2081 16.9848C10.9784 16.9867 10.7894 16.9266 10.6072 16.7893C10.2651 16.5314 9.91202 16.2881 9.56313 16.0392C9.17858 15.7649 8.79356 15.4912 8.40884 15.2171C8.13126 15.0194 7.85491 14.8199 7.57515 14.6253C7.53643 14.5983 7.48134 14.5829 7.43371 14.5826C6.88797 14.5797 6.3422 14.5799 5.79644 14.5809C5.10759 14.5821 4.42511 14.5099 3.74587 14.4026C3.48618 14.3615 3.22769 14.3129 2.96872 14.2674C2.87958 14.2517 2.8745 14.2551 2.87449 14.3492C2.87432 15.3868 2.87452 16.4245 2.8742 17.4622C2.87413 17.6729 2.7572 17.847 2.56713 17.914C2.52233 17.9298 2.4719 17.9357 2.42405 17.9358C1.78814 17.9372 1.15223 17.9376 0.516319 17.9364C0.188896 17.9358 0.000856462 17.7455 0.000778646 17.4162C0.000365287 15.6697 0.000584393 13.9232 0.000584681 12.1767L0.000583219 12.1767ZM17.9552 13.6199C18.6495 13.6199 19.3439 13.6199 20.0383 13.6198C20.1197 13.6198 20.1605 13.5803 20.1607 13.5012C20.1608 12.6195 20.1608 11.7377 20.1607 10.856C20.1607 10.7787 20.1223 10.7401 20.0454 10.74C18.6518 10.74 17.2581 10.7399 15.8645 10.74C15.6785 10.74 15.5327 10.6612 15.4379 10.5035C15.0214 9.81088 14.6074 9.11668 14.1947 8.42174C14.1611 8.36512 14.1253 8.33936 14.0571 8.33952C13.1313 8.34159 12.2055 8.34008 11.2797 8.34319C11.2282 8.34337 11.1694 8.36559 11.1267 8.39562C10.7403 8.66732 10.3569 8.94315 9.9725 9.21758C9.62777 9.46367 9.28289 9.70954 8.93803 9.95545C8.6189 10.183 8.29967 10.4105 7.9806 10.6381C7.88018 10.7098 7.77034 10.7418 7.64531 10.7413C7.01674 10.7384 6.38814 10.7385 5.75956 10.7405C5.24008 10.7421 4.72333 10.7836 4.20836 10.8519C3.6163 10.9304 3.02959 11.0386 2.44994 11.1807C1.97477 11.2971 1.50387 11.431 1.03102 11.557C0.986177 11.5689 0.952619 11.5834 0.953016 11.6429C0.95541 12.001 0.954842 12.359 0.953413 12.7171C0.953234 12.7619 0.9717 12.783 1.01211 12.7951C1.14728 12.8358 1.281 12.8816 1.41691 12.9195C2.14668 13.1233 2.88252 13.3005 3.63073 13.424C4.36492 13.5451 5.10266 13.6225 5.8478 13.6202C6.44958 13.6184 7.05137 13.6205 7.65315 13.6195C7.76874 13.6193 7.8729 13.6455 7.96854 13.7142C8.36984 14.0027 8.77275 14.289 9.17536 14.5757C9.82389 15.0375 10.4732 15.4981 11.1203 15.9619C11.1798 16.0045 11.2378 16.0209 11.3091 16.0208C12.1764 16.0192 13.0438 16.0152 13.9111 16.0238C14.0771 16.0254 14.1728 15.986 14.2608 15.8331C14.6307 15.1895 15.0217 14.558 15.3985 13.9183C15.5179 13.7157 15.6782 13.6162 15.9159 13.618C16.5956 13.6233 17.2754 13.6199 17.9552 13.6199V13.6199ZM23.0402 12.1882C23.0402 10.6345 23.0402 9.08073 23.0402 7.52698C23.0402 7.5002 23.0389 7.47336 23.04 7.44663C23.0421 7.39677 23.0193 7.37868 22.9696 7.37884C22.5043 7.38029 22.039 7.37706 21.5738 7.38172C21.3392 7.38406 21.1486 7.56917 21.1267 7.80274C21.1211 7.8632 21.1206 7.92432 21.1206 7.98514C21.1204 10.7931 21.1204 13.601 21.1205 16.409C21.1205 16.4455 21.1202 16.4821 21.1226 16.5185C21.1404 16.7898 21.3227 16.9752 21.5939 16.9787C22.0518 16.9845 22.5098 16.98 22.9677 16.9815C23.0221 16.9816 23.043 16.96 23.0401 16.9079C23.0385 16.8788 23.0402 16.8495 23.0402 16.8202C23.0402 15.2762 23.0402 13.7322 23.0402 12.1882L23.0402 12.1882ZM18.7175 18.8986C19.3166 18.8986 19.9157 18.8986 20.5149 18.8985C20.5969 18.8985 20.638 18.8564 20.6382 18.7722C20.6384 18.4046 20.6367 18.0369 20.6396 17.6693C20.6402 17.5956 20.6188 17.5413 20.5668 17.4885C20.3211 17.2393 20.1884 16.9367 20.1651 16.5887C20.1601 16.5134 20.1345 16.4971 20.0644 16.4972C19.0098 16.4992 17.9553 16.4985 16.9007 16.4986C16.802 16.4986 16.8015 16.4991 16.8015 16.6007C16.8014 17.3311 16.8013 18.0616 16.8015 18.792C16.8015 18.8981 16.8019 18.8985 16.9129 18.8985C17.5144 18.8986 18.116 18.8986 18.7175 18.8986V18.8986ZM18.7149 5.46328C18.1133 5.46328 17.5117 5.46323 16.9101 5.46333C16.8018 5.46334 16.8015 5.46361 16.8015 5.57088C16.8014 6.29411 16.8014 7.01734 16.8014 7.74057C16.8015 7.86081 16.8016 7.86116 16.9214 7.86117C17.9615 7.86127 19.0015 7.86124 20.0416 7.86122C20.0586 7.86122 20.0757 7.85999 20.0927 7.86091C20.1426 7.86363 20.1598 7.83932 20.1627 7.79086C20.1847 7.42301 20.3296 7.11028 20.5847 6.8452C20.6145 6.81426 20.6355 6.76099 20.636 6.71782C20.6399 6.33311 20.6385 5.94834 20.6381 5.56359C20.638 5.46445 20.6364 5.46341 20.5344 5.46338C19.9279 5.46323 19.3214 5.46331 18.7149 5.46328V5.46328ZM0.960309 13.7747C0.957731 13.8047 0.95433 13.8259 0.954325 13.8471C0.954065 14.8645 0.954616 15.8819 0.952904 16.8994C0.952793 16.9653 0.977138 16.9823 1.03855 16.9818C1.3039 16.9795 1.56931 16.9793 1.83466 16.9819C1.89864 16.9825 1.91908 16.96 1.91899 16.897C1.91759 15.9696 1.9176 15.0423 1.91901 14.1149C1.91909 14.0577 1.89681 14.034 1.84379 14.0197C1.58778 13.9505 1.33266 13.8781 1.07721 13.8069C1.04061 13.7967 1.00395 13.7867 0.960309 13.7747H0.960309ZM0.958678 10.58C0.984942 10.5761 0.999429 10.5754 1.01304 10.5716C1.29688 10.4925 1.58031 10.412 1.86466 10.3348C1.91677 10.3207 1.91812 10.287 1.91811 10.2464C1.91799 9.31839 1.91755 8.39034 1.91907 7.4623C1.91917 7.39876 1.89875 7.37753 1.8348 7.37823C1.57413 7.38105 1.31342 7.37923 1.05272 7.37945C0.954463 7.37953 0.954103 7.37994 0.954094 7.48183C0.954006 8.48295 0.954011 9.48408 0.954227 10.4852C0.954233 10.5139 0.956851 10.5426 0.958678 10.58Z"
          fill="white"
          fill-opacity="0.5"
        />
        <path
          d="M5.99596 4.97901C6.54657 4.97906 7.09718 4.97751 7.64777 4.97965C7.97741 4.98092 8.24937 5.10665 8.4488 5.3736C8.56548 5.52977 8.63358 5.7057 8.63397 5.9024C8.63528 6.56734 8.63718 7.2323 8.63352 7.89723C8.63085 8.38322 8.19997 8.80899 7.71305 8.8146C7.56689 8.81628 7.42068 8.81643 7.27453 8.81451C7.21942 8.81378 7.19528 8.83187 7.19698 8.89042C7.20023 9.00237 7.19604 9.11452 7.19843 9.22651C7.19953 9.27813 7.18341 9.30229 7.12832 9.30202C6.85546 9.30067 6.58259 9.30086 6.30973 9.30201C6.25561 9.30223 6.23666 9.27795 6.23741 9.22631C6.239 9.11673 6.23568 9.00706 6.23826 8.89752C6.23963 8.83951 6.22069 8.81265 6.15899 8.81438C6.05187 8.81738 5.94455 8.81754 5.83745 8.81433C5.77503 8.81246 5.75755 8.84027 5.75907 8.8977C5.76178 8.99993 5.76004 9.10228 5.75952 9.20458C5.75905 9.29642 5.75468 9.30146 5.66577 9.30162C5.40752 9.30208 5.14926 9.30007 4.89104 9.30285C4.82278 9.30358 4.79399 9.28305 4.79733 9.21144C4.80197 9.11179 4.79879 9.01176 4.79822 8.9119C4.79768 8.81727 4.79575 8.81684 4.69821 8.81482C4.51579 8.81106 4.33091 8.82352 4.15149 8.79802C3.71067 8.73536 3.36072 8.32534 3.3583 7.88021C3.35474 7.22502 3.35424 6.56978 3.35849 5.9146C3.36141 5.46492 3.72526 5.05752 4.16995 4.996C4.24682 4.98536 4.32502 4.97989 4.40263 4.97969C4.93374 4.97831 5.46485 4.97897 5.99596 4.97902L5.99596 4.97901ZM5.99629 5.94109C5.47025 5.94109 4.94421 5.94096 4.41817 5.94122C4.32166 5.94127 4.31856 5.94411 4.31851 6.03858C4.31817 6.61319 4.31818 7.18781 4.31846 7.76242C4.31851 7.85574 4.32297 7.86009 4.41912 7.86011C5.4712 7.86032 6.52328 7.86031 7.57537 7.86009C7.67505 7.86007 7.67907 7.85612 7.67912 7.75787C7.67943 7.18813 7.67942 6.61839 7.67916 6.04865C7.67912 5.94163 7.67838 5.9412 7.56711 5.94117C7.0435 5.941 6.5199 5.94109 5.99629 5.9411L5.99629 5.94109Z"
          fill="white"
          fill-opacity="0.5"
        />
        <path
          d="M5.99518 19.3781C5.43986 19.3781 4.88454 19.3804 4.32924 19.3774C3.82904 19.3746 3.42604 19.016 3.36388 18.5244C3.35871 18.4835 3.35785 18.4419 3.35782 18.4005C3.35746 17.7772 3.35722 17.1538 3.35767 16.5305C3.35808 15.9669 3.7824 15.5418 4.34676 15.5389C4.46367 15.5383 4.58058 15.5391 4.69749 15.5386C4.79582 15.5381 4.79812 15.5356 4.79863 15.4343C4.79914 15.3345 4.80041 15.2346 4.7986 15.1348C4.79764 15.0819 4.81943 15.0608 4.87225 15.0611C5.14503 15.0622 5.41782 15.0622 5.6906 15.0611C5.74103 15.0609 5.76029 15.0829 5.75991 15.1313C5.75903 15.2409 5.76169 15.3505 5.75964 15.46C5.7586 15.5152 5.77838 15.5402 5.83576 15.539C5.94531 15.5368 6.05496 15.5372 6.16454 15.5388C6.21732 15.5395 6.23895 15.5173 6.23815 15.4646C6.23651 15.3575 6.23978 15.2503 6.23753 15.1432C6.23631 15.085 6.25685 15.0601 6.31784 15.0606C6.58574 15.0625 6.85367 15.0622 7.12158 15.0608C7.17701 15.0605 7.20044 15.0797 7.19887 15.1374C7.1959 15.2469 7.20005 15.3566 7.1976 15.4661C7.19638 15.5203 7.21872 15.5395 7.27099 15.539C7.4098 15.5376 7.54869 15.5366 7.68746 15.5396C8.16024 15.5501 8.55401 15.8927 8.62574 16.3556C8.63352 16.4058 8.63454 16.4575 8.63459 16.5084C8.63516 17.1391 8.63511 17.7698 8.63492 18.4005C8.63476 18.9529 8.22134 19.3737 7.66842 19.3773C7.1107 19.3809 6.55293 19.3781 5.99518 19.3781H5.99518ZM6.0036 16.4991C5.47502 16.4991 4.94644 16.499 4.41787 16.4992C4.31981 16.4992 4.31888 16.4997 4.31883 16.5953C4.31852 17.17 4.31853 17.7447 4.31881 18.3195C4.31886 18.4168 4.3214 18.4194 4.41574 18.4194C5.47046 18.4197 6.52518 18.4196 7.57989 18.4194C7.67574 18.4194 7.67933 18.4162 7.67939 18.3216C7.67976 17.7469 7.67975 17.1722 7.67942 16.5975C7.67936 16.5 7.67809 16.4993 7.58201 16.4992C7.05587 16.4991 6.52974 16.4991 6.0036 16.4991L6.0036 16.4991Z"
          fill="white"
          fill-opacity="0.5"
        />
        <path
          d="M13.918 12.1862C13.918 12.6513 13.9171 13.1164 13.9185 13.5815C13.919 13.7402 13.8775 13.8792 13.7541 13.9868C13.6741 14.0566 13.583 14.0973 13.4755 14.0973C12.6596 14.0972 11.8436 14.1049 11.0277 14.095C10.0764 14.0835 9.29522 13.4194 9.14877 12.4912C9.03894 11.7951 9.257 11.2028 9.78527 10.7322C10.1381 10.4179 10.5581 10.2637 11.0275 10.2598C11.8239 10.2533 12.6204 10.2563 13.4168 10.2584C13.7164 10.2592 13.9154 10.4631 13.9172 10.769C13.9199 11.2414 13.9179 11.7138 13.918 12.1862V12.1862ZM11.9225 11.2203L11.9225 11.2207C11.6205 11.2207 11.3185 11.2179 11.0165 11.2213C10.5044 11.2271 10.0912 11.6388 10.0781 12.1517C10.0639 12.7103 10.489 13.1369 11.0715 13.1406C11.6682 13.1444 12.265 13.1416 12.8617 13.1413C12.9581 13.1413 12.9613 13.1382 12.9613 13.0434C12.9616 12.4687 12.9616 11.8941 12.9614 11.3194C12.9614 11.2209 12.9606 11.2205 12.8578 11.2204C12.5461 11.2202 12.2343 11.2203 11.9225 11.2203V11.2203Z"
          fill="white"
          fill-opacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1615_20993">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { PlayerLiveTimingDataType } from '@/store/stores/collectionModule/documents/liveTiming/PlayerLiveTiming'

/**
 * レース動画再生画面: GPS詳細 ランキング プレイヤーパーツ コンポーネント
 */
export default defineComponent({
  name: 'GpsRankingPlayerParts',
  props: {
    /**
     * 選択中選手ID
     */
    selectedID: {
      type: String,
      default: '',
    },
    /**
     * 選手のライブタイミング情報
     */
    player: {
      type: Object as PropType<PlayerLiveTimingDataType>,
      required: true,
    },
    /**
     * ランキング
     */
    rank: {
      type: String,
      required: true,
    },
    /**
     * 選手画像
     */
    img: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const ranking = computed(() => props.rank)
    const selectedPlayerID = computed(() => props.selectedID)

    /**
     * 選手の顔写真ファイルのパス
     */
    const imgPath = computed(() => props.img || './assets/img/common/card/icon_player__null.svg')

    /**
     * ランキングフォントサイズ調整
     */
    const rankingFontSizeSmall = computed(() => ranking.value.length > 1)

    return {
      selectedPlayerID,
      ranking,
      rankingFontSizeSmall,
      imgPath,
    }
  },
})
</script>

<style lang="scss" scoped>
.gps-ranking-player-parts {
  position: relative;
  width: 134px;
  min-width: 134px;

  &__card {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: repeat(3, auto);
    grid-gap: 8px;
    width: 134px;
    padding: 8px 8px 6px;
    color: #fff;
    border-radius: 8px;
    background: linear-gradient(
      293.64deg,
      rgba(255, 255, 255, 0.32) -7.61%,
      rgba(255, 255, 255, 0.18) 56.2%
    );
  }

  &__img {
    grid-area: 1 / 1 / 3 / 2;

    img {
      width: 50px;
      min-width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  &__lap {
    grid-area: 1 / 2 / 2 / 4;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    font-size: 9px;
    font-feature-settings: initial;
  }

  &__position {
    grid-area: 2 / 2 / 3 / 4;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    justify-content: flex-end;
    font-weight: 600;
    gap: 3px;

    &-label {
      display: block;
      font-size: 10px;
      line-height: 12px;
    }

    &-num {
      display: block;
      font-family: $fontHeading;
      font-size: 32px;
      line-height: 0.8;

      &.is-small {
        font-size: 16px;
        line-height: 1;
      }
    }
  }

  &__name {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-area: 3 / 1 / 4 / 4;
    max-width: 118px;
    padding-top: 6px;
    line-height: 1;

    &::before {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      display: block;
      content: '';
      height: 1px;
      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0.6) 3.42%,
        rgba(255, 255, 255, 0.8) 52.72%,
        rgba(255, 255, 255, 0.6) 100%
      );
      opacity: 0.5;
      transform: skewX(45deg);
    }

    span {
      display: block;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 10px;
    }

    .abbreviation {
      display: none;
    }
  }

  &__diff {
    display: none;
    position: absolute;
    top: 115px;
    left: -4px;
    transform: translateX(-50%);
    font-size: 9px;
    letter-spacing: 0.04em;
    color: #fff;
  }

  &__car-icon {
    position: absolute;
    bottom: -34px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &:not(:first-child) {
    .gps-ranking-player-parts {
      &__diff {
        display: block;
      }
    }

    &::after {
      position: absolute;
      top: 110px;
      left: -4px;
      display: block;
      content: '';
      width: 98px;
      height: 1px;
      background: #fff;
      opacity: 0.5;
      transform: skewX(45deg) translateX(-50%);
    }
  }

  &--current {
    .gps-ranking-player-parts {
      &__card {
        background: linear-gradient(0deg, rgba(0, 219, 166, 0.2), rgba(0, 219, 166, 0.2)),
          linear-gradient(
            293.64deg,
            rgba(255, 255, 255, 0.32) -7.61%,
            rgba(255, 255, 255, 0.18) 56.2%
          );
        color: $green-light;
      }

      &__name {
        &::before {
          background: linear-gradient(
            270deg,
            rgba(255, 255, 255, 0.6) 3.42%,
            rgba(255, 255, 255, 0.8) 52.72%,
            rgba(255, 255, 255, 0.6) 100%
          );
        }
      }

      &__car-icon {
        path {
          fill: $green-light;
          fill-opacity: 0.7;
        }
      }
    }
  }
}

@media screen and (max-height: 680px), screen and (max-width: 320px) {
  .gps-ranking-player-parts {
    width: 124px;
    min-width: 124px;

    &__card {
      grid-gap: 0 3px;
      width: 124px;
      padding: 6px;
    }

    &__img {
      grid-area: 1 / 1 / 4 / 2;

      img {
        width: 28px;
        min-width: 28px;
        height: 28px;
      }
    }

    &__lap {
      grid-area: 1 / 2 / 2 / 3;
      justify-content: flex-start;
      width: 55px;
      padding-left: 3px;
      line-height: 8px;
      font-feature-settings: 'palt' on;
    }

    &__position {
      grid-area: 1 / 3 / 4 / 4;
      flex-flow: column nowrap;
      align-items: center;
      align-content: flex-end;
      justify-content: space-between;
      justify-items: center;
      gap: 0;

      &-label {
        font-size: 9px;
        line-height: 12px;
      }

      &-num {
        padding-top: 1px;
        font-size: 17px;
        line-height: 1;

        &.is-small {
          font-size: 11px;
        }
      }
    }

    &__name {
      position: relative;
      grid-area: 2 / 2 / 4 / 3;
      width: 55px;
      max-width: 55px;
      padding-top: 3px;

      &::before {
        position: absolute;
        top: 1px;
      }

      span {
        font-size: 9px;
      }

      .name {
        display: none;
      }

      .abbreviation {
        display: block;
        padding-left: 3px;
      }
    }

    &__car-icon {
      bottom: -26px;
    }

    &__diff {
      top: 60px;
    }

    &:not(:first-child) {
      &::after {
        top: 56px;
        width: 98px;
      }
    }
  }
}
</style>
